import './BuiltPM.css';
// icons
import SparklesIcon from '../../../assets/icons/sparkles.svg';
import SparklesColorIcon from '../../../assets/icons/sparkles-color-full.svg';
import GlobeIcon from '../../../assets/icons/globe-europe-africa.svg';
import ArrowIcon from '../../../assets/icons/arrow-up-right.svg';

export default function BuiltPM() {

    return (
        <div>
            <section className='built-pm'>
                <div className='built-pm-container'>
                    <div className='built-pm-header'>
                        <div style={{
                            width: '28px',
                            height: '28px',
                            padding: '4px',
                            background: '#0D9488',
                            borderRadius: 9.70,
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: 12,
                            display: 'inline-flex',
                            marginRight: '16px'
                        }}>
                            <div style={{
                                width: '24px',
                                height: '24px',
                                position: 'relative'
                            }}>
                                <img src={SparklesIcon} width={'24px'}/>
                            </div>
                        </div>
                        <div style={{
                            height: '36px',
                            paddingLeft: 32,
                            paddingRight: 32,
                            boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                            borderRadius: 36,
                            overflow: 'hidden',
                            border: '1px #0D9488 solid',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: 2,
                            display: 'inline-flex'
                        }}>
                            <div style={{
                                color: '#0D9488',
                                fontSize: 16,
                                fontWeight: '600',
                                wordWrap: 'break-word'
                            }}>Built for product managers
                            </div>
                        </div>
                    </div>
                    <div className='built-pm-content'>
                        <div className='divider-bar-pm'>
                        </div>
                        <div className='built-pm-box'>
                            <h6 className="section-title">
                                Provide your team with actionable insights
                            </h6>
                            <h6 className="section-subtitle">
                                Streamline communication, enhance collaboration, and optimize performance.
                            </h6>
                            <div className="built-pm-cards-container">
                                <div className="built-pm-card">
                                    <div style={{
                                        width: '48px',
                                        height: '48px',
                                        position: 'relative',
                                        marginBottom: '16px'
                                    }}>
                                        <img src={SparklesColorIcon} width={'48px'}/>
                                    </div>
                                    <h1 style={{
                                        color: '#0891B2',
                                    }}>Our Own AI model
                                    </h1>
                                    <p>
                                        We have our own ML models, on our own European servers. Your data never leaves
                                        our servers. Simple as that. The privacy of your customers private data is a non
                                        negotiable for us.
                                    </p>
                                </div>
                                <div className="built-pm-card">
                                    <div style={{
                                        width: '48px',
                                        height: '48px',
                                        position: 'relative',
                                        marginBottom: '16px'
                                    }}>
                                        <img src={GlobeIcon} width={'48px'}/>
                                    </div>
                                    <h1 style={{
                                        color: '#2563EB',
                                    }}>GDPR Compliant
                                    </h1>
                                    <p>
                                        We have our own ML models, on our own European servers. Your data never leaves
                                        our servers. Simple as that. The privacy of your customers private data is a non
                                        negotiable for us.
                                    </p>

                                </div>
                                <div className="built-pm-card">
                                    <div style={{
                                        width: '48px',
                                        height: '48px',
                                        position: 'relative',
                                        marginBottom: '16px'
                                    }}>
                                        <img src={ArrowIcon} width={'48px'}/>
                                    </div>
                                    <h1 style={{
                                        color: '#16A34A',
                                    }}>Built for scale
                                    </h1>
                                    <p>
                                        Building for scale is in our DNA. We collect and analyze your customer feedback
                                        at scale. It is because we are committed to delivering you deeper customer
                                        insights at your fingertips.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}
